// extracted by mini-css-extract-plugin
export default {"pageHero":"PrivacyPage_pageHero__dC1XK","privacyContent":"PrivacyPage_privacyContent__mXA6K","privacyTitle":"PrivacyPage_privacyTitle__xThd6"};